import { LocalizableString } from 'models/cms/common/types';

export enum LiveStreamType {
  Booth,
}

interface LiveStreamChannel<T extends LiveStreamType, P> {
  type: T;
  data: P;
}

export type LiveStreamBoothChannel = LiveStreamChannel<LiveStreamType.Booth, {
  boothId: string;
  boothName: LocalizableString | null;
}>

export interface LiveStreamJoinActionPayload<C extends LiveStreamChannel<any, any>> {
  channel: C;
}

export interface BoothLiveStreamingLastTimeStampUpdateActionPayload {
  boothId: string;
  streamingLastTimeStamp: string;
}

export interface BoothLiveStreamingStatusUpdateActionPayload {
  boothId: string;
  streamingStatus: boolean;
}

export interface BoothLiveStreamingStatusCleanUpActionPayload {
  excludeBoothIds: string[];
}

export interface LiveStreamState {
  currentChannel: LiveStreamChannel<LiveStreamType, any> | null;
  boothLiveStreamingLastTimeStamp: Record<string, string>;
  boothLiveStreamingStatus: Record<string, boolean>;
  isClosable: boolean;
}
